import { LOCALSTORAGES } from "@/constants/constant";
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const GuestRoute: React.FC = () => {
  const token = localStorage.getItem(LOCALSTORAGES.TOKEN);

  // if (token) {
  //   // Already logged in → go to dashboard
  //   return <Navigate to="/dashboard" replace />;
  // }

  return <Outlet />;
};

export default GuestRoute;
